import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: { id: number };
  handleDetail: (id: number) => void;
}

export const GrossMarginRequestActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex>
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item.id)}
          data-testid="gross-margin-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
